import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Typography,
  Box,
  makeStyles,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@material-ui/core";
import { connect } from "react-redux";
import { setBreadcrumps } from "../../actions";
import Header from "../../components/Header";
import axios from "../../api";
import HistoryIcon from "@material-ui/icons/History";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    margin: theme.spacing(2),
  },
  card: {
    height: "100%",
    borderRadius: theme.spacing(2),
    transition: "transform 0.2s",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: theme.shadows[4],
    },
  },
  metricValue: {
    fontWeight: "bold",
    fontSize: "2rem",
    marginTop: theme.spacing(1),
  },
  healthGood: { color: theme.palette.success.main },
  healthWarning: { color: theme.palette.warning.main },
  healthDanger: { color: theme.palette.error.main },
  tableContainer: {
    marginTop: theme.spacing(4),
  },
  statusIcon: {
    verticalAlign: "middle",
    marginRight: theme.spacing(1),
  },
}));

function AuditDashboard(props) {
  const { setBreadcrumps, token } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [health, setHealth] = useState(null);
  const [history, setHistory] = useState([]);

  // Estados para el modal
  const [modalOpen, setModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [batchDetails, setBatchDetails] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    setBreadcrumps([{ name: "Egresados" }, { name: "Auditoría y Validación" }]);
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const headers = { "access-token": token };
      const [resHealth, resHistory] = await Promise.all([
        axios.get("/audit/health", { headers }),
        axios.get("/audit/history", { headers }),
      ]);
      setHealth(resHealth.data.health);
      setHistory(resHistory.data.history);
    } catch (error) {
      console.error("Error fetching audit data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDetails = async (date) => {
    setSelectedDate(date);
    setModalOpen(true);
    setModalLoading(true);
    try {
      const headers = { "access-token": token };
      axios.get(`/audit/batch/${date}`, { headers }).then((res) => {
        if (res.data.success) {
          setBatchDetails(res.data.details);
        } else {
          Swal.fire(
            "Error",
            "No se pudieron cargar los detalles: " + res.data.message,
            "error",
          );
          setModalOpen(false);
        }
      });
    } catch (error) {
      console.error("Error fetching batch details:", error);
      Swal.fire("Error", "Error de conexión con el servidor", "error");
    } finally {
      setModalLoading(false);
    }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const getHealthColor = (score) => {
    if (score >= 90) return classes.healthGood;
    if (score >= 70) return classes.healthWarning;
    return classes.healthDanger;
  };

  return (
    <Paper elevation={0} className={classes.container}>
      <Header
        search={false}
        button={false}
        backButton={true}
        backRoute={"/graduated"}
        crump={[{ name: "Egresados" }, { name: "Auditoría" }]}
      />

      <Box mt={3}>
        <Typography variant="h5" gutterBottom color="primary">
          Centro de Auditoría y Verificación de Datos
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Revise la integridad de la base de datos y consulte el historial
          detallado de importaciones.
        </Typography>

        {/* <Grid container spacing={3} mt={4}>
          <Grid item xs={12} md={4}>
            <Card className={classes.card}>
              <CardContent>
                <Typography variant="subtitle2" color="textSecondary">Puntaje de Salud de Datos</Typography>
                <Typography className={`${classes.metricValue} ${getHealthColor(health?.healthScore)}`}>
                  {health?.healthScore}%
                </Typography>
                <Box mt={1}>
                  <Typography variant="caption">Basado en completitud de registros críticos</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card className={classes.card}>
              <CardContent>
                <Typography variant="subtitle2" color="textSecondary">Inconsistencias Detectadas</Typography>
                <Box mt={2}>
                  <Typography variant="body2">
                    <ErrorIcon fontSize="small" color="error" className={classes.statusIcon} />
                    {health?.anomalies?.missingEmail} sin correo electrónico
                  </Typography>
                  <Typography variant="body2" style={{ marginTop: 8 }}>
                    <ErrorIcon fontSize="small" color="action" className={classes.statusIcon} />
                    {health?.anomalies?.missingBirthDate} sin fecha de nacimiento
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card className={classes.card}>
              <CardContent>
                <Typography variant="subtitle2" color="textSecondary">Total Egresados</Typography>
                <Typography className={classes.metricValue}>
                  {health?.totalGraduates.toLocaleString()}
                </Typography>
                <Box mt={1}>
                  <CheckCircleIcon fontSize="small" color="primary" className={classes.statusIcon} />
                  <Typography variant="caption" component="span">Registros activos en producción</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid> */}

        <Box className={classes.tableContainer}>
          <Typography variant="h6" gutterBottom>
            <HistoryIcon className={classes.statusIcon} color="primary" />
            Historial de Importaciones por Lotes
          </Typography>
          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Fecha de Proceso</TableCell>
                  <TableCell align="center">Registros Totales</TableCell>
                  <TableCell align="center">Egresados Únicos</TableCell>
                  <TableCell>Programas Afectados</TableCell>
                  <TableCell align="right">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {history.map((row) => (
                  <TableRow key={row.import_date}>
                    <TableCell>
                      {moment(row.import_date).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell align="center">{row.total_records}</TableCell>
                    <TableCell align="center">{row.unique_graduates}</TableCell>
                    <TableCell>
                      <Typography
                        variant="caption"
                        noWrap
                        style={{ maxWidth: 300, display: "block" }}
                      >
                        {row.programs}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        startIcon={<VisibilityIcon />}
                        onClick={() => handleOpenDetails(row.import_date)}
                      >
                        Ver Detalles
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {/* Modal de Detalles */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Detalles del Lote:{" "}
          {selectedDate ? moment(selectedDate).format("DD/MM/YYYY") : ""}
          <IconButton
            style={{ position: "absolute", right: 8, top: 8 }}
            onClick={() => setModalOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {modalLoading ? (
            <Box display="flex" justifyContent="center" p={4}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Identificación</TableCell>
                    <TableCell>Nombre</TableCell>
                    {/* <TableCell>Email</TableCell> */}
                    <TableCell>Programa</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {batchDetails.map((item, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{item.identificacion}</TableCell>
                      <TableCell>{item.nombre}</TableCell>
                      {/* <TableCell>{item.email || "N/A"}</TableCell> */}
                      <TableCell>{item.programa}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}

const mapStateToProps = (state) => ({
  token: state.token,
  user: state.user,
});

const mapDispatchToProps = {
  setBreadcrumps,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditDashboard);
